<template src="./user-settlements.html">
</template>

<script>
  import Vue from 'vue'
  import { EventBus } from '@/router/bus'
  import Loader from '@/components/misc/Loader'
  import ContextHeader from '@/components/misc/context-header/ContextHeader'
  import Papa from 'papaparse'

  export default {
    components: {
      Loader,
      ContextHeader
    },
    data () {
      return {
        settleByIdf: false,
        load: false,
        errorList: [],
        settlementData: null,
        loadedSettlementData: null,
        parsedSettlementData: null
      }
    },
    computed: {
      showErrorContainer () {
        return this.errorList.length > 0
      }
    },
    methods: {
      fileLoaded: function (e) {
        this.errorList = []
        const file = e.target.files[0]
        if (file && file.type === 'text/csv') {
          this.readAndParseCSV(file)
        } else if (file && file.type === 'application/json') {
          this.readJSON(file)
        }
      },
      readAndParseCSV (file) {
        Papa.parse(file, {
          preview: 1200,
          header: true,
          skipEmptyLines: true,
          complete: (results) => {
            if (results.data.length > 1000) {
              EventBus.$emit('alert', {
                variant: 'danger',
                message: 'Величина ЈСОН фајла превазилази 1000 редова',
                errors: []
              })
              return
            }
            this.loadedSettlementData = results.data
            this.parsedSettlementData = this.csvToJson(this.loadedSettlementData)
          },
          error: (error) => {
            this.logConsole('Error parsing CSV: ', [error.message]())
          }
        })
      },
      async readJSON (file) {
        try {
          const text = await file.text()
          this.loadedSettlementData = JSON.parse(text)
          if (this.loadedSettlementData.length > 1000) {
            EventBus.$emit('alert', {
              variant: 'danger',
              message: 'Величина ЈСОН фајла превазилази 1000 редова',
              errors: []
            })
          }
          this.parsedSettlementData = this.csvToJson(this.loadedSettlementData)
        } catch (error) {
          this.logConsole('Error parsing JSON: ', error)
          EventBus.$emit('alert', {
            variant: 'danger',
            message: 'Грешка у формату ЈСОН фајла: ' + error,
            errors: []
          })
        }
      },
      csvToJson: function (csv) {
        const result = []

        for (let i = 0; i < csv.length; i++) {
          const currentline = csv[i]

          result.push({
            invoiceId: currentline['IDF'],
            settledAmount: currentline['IzmireniIznos'],
            settlementDate: currentline['DatumIzmirenja'],
            bank: currentline['Banka'],
            creditAccount: currentline['RacunOdobrenja'],
            debitAccount: currentline['RacunZaduzenja'],
            referenceNumber: currentline['IdentifikatorPlacanja'],
            isCompensationSettlement: currentline['Kompenzacija'] === '1'
          })
        }

        return result
      },
      confirmSettlement () {
        this.$refs.settleInvoiceModal.show()
      },
      submitSettlement: function (validate) {
        if (this.parsedSettlementData === null) { return }
        const url = validate ? `${Vue.$apiConfig.registerUserSettlementPost}?validateSettlement=true` : Vue.$apiConfig.registerUserSettlementPost
        this.load = true
        this.$http.post(url, this.parsedSettlementData)
          .then(response => {
            this.errorList = []
            this.logConsole(response)
            this.load = false
            // get body data
            if (!!response.data && Array.isArray(response.data.payload)) {
              response.data.payload.forEach(element => {
                if (element.settlementError) {
                  this.errorList.push(element)
                }
              })
            }
            if (this.errorList.length === 0) {
              let message = validate ? 'Све достављене фактуре су исправне' : 'Успешно сте регистровали измирења фактура'
              if (!validate) {
                this.loadedSettlementData = null
                this.settlementData = null
              }

              EventBus.$emit('alert', {
                variant: 'success',
                message: message,
                errors: []
              })
            }
          }, error => {
            this.logConsole(error)
            if (!!error.data && Array.isArray(error.data.errors)) {
              error.data.errors.forEach(element => {
                if (element && element.field) {
                  const startIndex = element.field.indexOf('[') + 1
                  const endIndex = element.field.indexOf(']')
                  const match = element.field.substring(startIndex, endIndex)
                  this.errorList.push({
                    settlement: this.parsedSettlementData[match],
                    settlementError: element
                  })
                }
              })
            } else {
              this.formatErrorResponse(error, 'invoices.invoiceLimitExceeded')
            }
            this.load = false
          })
      }
    }
  }
</script>

<style lang="scss" type="text/scss" scoped>
  @import '~@/assets/scss/variables.scss';

  .text-dark {
    font-weight: 600;
    font-size: 12pt;
    color: $font-color-dark !important;
  }

  .list-container {
    height: 320px;
    overflow-y: scroll;
    overflow-x:hidden;
    font-size: 11pt;
  }
  
</style>



// WEBPACK FOOTER //
// UserSettlements.vue?5b892c4e